import * as React from 'react';
import { validateIconType } from './utils';
import { createComponent, styled } from '@workday/canvas-kit-react/common';
import { Box } from '@workday/canvas-kit-react/layout';
const StyledIconSpan = styled(Box.as('span'))({
    display: 'inline-block',
    '> svg': { display: 'block' },
}, ({ shouldMirror, styles }) => ({
    ...styles,
    transform: shouldMirror ? 'scaleX(-1)' : undefined,
}));
export const Svg = createComponent('span')({
    displayName: 'Svg',
    Component: ({ src, type, ...elemProps }, ref, Element) => {
        try {
            validateIconType(src, type);
        }
        catch (e) {
            console.error(e);
            return null;
        }
        return (React.createElement(StyledIconSpan, Object.assign({ as: Element, dangerouslySetInnerHTML: { __html: src.svg } }, elemProps, { ref: ref })));
    },
});
